import {Provider} from '@angular/core';
import {AUTH_PROVIDER} from './auth-interceptor';
import {HttpHeaderInterceptor} from './http-headers.interceptor';
import { HTTP_LOADER_PROVIDER } from '@ui-app/http-interceptors/http-loader.interceptor';

export const SharedInterceptors: Provider[] = [
    AUTH_PROVIDER,
    HttpHeaderInterceptor,
    HTTP_LOADER_PROVIDER,
];
